import { createContext, useContext } from "react";

export type WaitlistModalContextValue = {
  /** Opens the waitlist modal (phone/email verification -> confirmation). */
  openWaitlistModal: () => void;
};

// No-op fallback so `useWaitlistModal()` is safe to call outside a provider
// (e.g. in Storybook or during prerendering, where the modal isn't mounted).
const NOOP_CONTEXT: WaitlistModalContextValue = {
  openWaitlistModal: () => {},
};

export const WaitlistModalContext =
  createContext<WaitlistModalContextValue>(NOOP_CONTEXT);

/**
 * Exposes `openWaitlistModal()`. Returns a no-op when rendered outside a
 * `WaitlistModalProvider`, so callers never need to guard against a missing
 * provider.
 *
 * Lives in its own module (rather than alongside `WaitlistModalProvider`) so
 * that `IrisCtaLink` - which the provider renders - can consume the hook
 * without creating a circular import between the two files.
 */
export function useWaitlistModal(): WaitlistModalContextValue {
  return useContext(WaitlistModalContext);
}
